import { IVisaType } from "../../../../core/src/models/visa-type/models/i-visa-type";
import { BaseStoreFactory } from "./factories/base-store.factory";

export const getVisaTypeFlatStore = BaseStoreFactory.Create<IVisaType>('vacancy-type-flat')
